import AppConstants from "../constants";
import { CountryUrlKey } from "./utiles.types";


export const getCountryUrl = (): string | null => {
  const countryUrl = sessionStorage.getItem(AppConstants.COUNTRY_URL);
  return countryUrl ? countryUrl : null; // Return null if no countryUrl is found
};


// Get a specific country URL by key (e.g., "ewings", "wings", "delve", etc.)
export const getCountryUrlByKey = (key: CountryUrlKey): string | null => {
  const url = sessionStorage.getItem(`${AppConstants.COUNTRY_URL}_${key.toUpperCase()}`);
  return url ? url : null;
};

export const storeCountryUrlsInSession = (urls: Record<string, string>) => {
  if (urls && typeof urls === "object") {
    Object.entries(urls).forEach(([key, value]) => {
      if (key.toLowerCase() !== "oneclick") { 
        sessionStorage.setItem(
          `${AppConstants.COUNTRY_URL}_${key.toUpperCase()}`,
          value
        );
      }
    });
  }
};

